var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import createElement from './createElement';
// Global helpers
import renderText from './renderText';
import api from '../core/utils/api';
import handleError from '../core/utils/handleError';
import { commentTemplate, flowerTemplate, candleTemplate, replyCard, } from '../visual-components/rememberMe-condolence-views';
import submitReplyCard from './rememberMe-condolence-reply';
import svgs from '../visual-components/svgs';
import internalEvents from './internalEvents';
var handleHeart = function (config, card, data, personId) {
    // Handle the heart icons
    //
    var clicked = false;
    var heartWrapper = card.querySelector('._msnlq-int-counts-heart');
    var heart = heartWrapper === null || heartWrapper === void 0 ? void 0 : heartWrapper.querySelector('._msnlq-in-c-g-i');
    if (heartWrapper && heart) {
        heart.addEventListener('click', function () {
            if (clicked) {
                return;
            }
            clicked = true;
            api.post("/person/".concat(personId, "/interaction/").concat(data.id, "/reaction"), {}, {
                'X-Widget-Id': config._id,
                'X-Widget-Instance-Id': config._widgetInstanceId,
                'X-Customer-Id': config._customerId,
                'X-Uri': window.location.href,
            })
                .then(function (response) {
                var heartCountEl = heartWrapper.querySelector('._msnlq-js-heart-count');
                var heartCount = parseInt(heartCountEl.innerText) + 1;
                heartCountEl.innerHTML = heartCount;
                heartWrapper.classList.add("_msnlq-heart-added");
                if (response && response.json) {
                    return response.json();
                }
                return {};
            })
                .catch(function (error) {
                handleError({
                    section: 'rememberMe Condoloences Card',
                    message: "Heart request failed",
                });
            });
        });
    }
};
var CondolenceCard = function (config, section, arg, personId) {
    var _a, _b, _c, _d, _e, _f, _g;
    var events = internalEvents(config);
    var card = createElement('div', [
        { type: 'class', value: '_mnslq-remeber-comment' },
    ]);
    // Determine condolence type
    var type = arg.type;
    // Payload for custom views
    var customPayload = {
        config: config,
        section: section,
        svgs: svgs,
        data: __assign(__assign({}, arg), { type: type }),
        renderText: renderText,
        events: events,
    };
    // Process condolence type
    if (type === 'write' || type === 'condolence') {
        if ((_a = section === null || section === void 0 ? void 0 : section.views) === null || _a === void 0 ? void 0 : _a.commentCard) {
            card.innerHTML = section.views.commentCard(customPayload);
        }
        else {
            card.innerHTML = commentTemplate(arg);
        }
        handleHeart(config, card, arg, personId);
        //
        // Handle media in the responses
        if (arg.media && arg.media.length > 0 && !((_b = section === null || section === void 0 ? void 0 : section.views) === null || _b === void 0 ? void 0 : _b.commentCard)) {
            var mediacontainer_1 = card.querySelector('._msnlq-rm-cm-gl-me');
            var showOverlay_1 = false;
            var imageIndex_1 = 0;
            var toggle_1 = function () {
                var overlay = card.querySelector('._msnlq-glr-overlay-wrap');
                if (showOverlay_1) {
                    overlay.classList.remove('_msnlq-glr-hide');
                }
                else {
                    overlay.classList.add('_msnlq-glr-hide');
                }
            };
            var changeImage_1 = function (index) {
                card
                    .querySelector('._msnlq-glr-overlay-wrap')
                    .querySelector('img').src = arg.media[index].url;
            };
            var openOverlay_1 = function (index) {
                imageIndex_1 = index;
                changeImage_1(imageIndex_1);
                showOverlay_1 = !showOverlay_1;
                toggle_1();
            };
            var closeOverlay_1 = function () {
                showOverlay_1 = !showOverlay_1;
                toggle_1();
            };
            var nextImage_1 = function () {
                imageIndex_1 = imageIndex_1 + 1;
                if (imageIndex_1 > arg.media.length - 1) {
                    imageIndex_1 = 0;
                }
                changeImage_1(imageIndex_1);
            };
            var prevImage_1 = function () {
                imageIndex_1 = imageIndex_1 - 1;
                if (imageIndex_1 === -1) {
                    imageIndex_1 = arg.media.length - 1;
                }
                changeImage_1(imageIndex_1);
            };
            arg.media.forEach(function (img, index) {
                var imageWrapper = createElement('div', [
                    { type: 'class', value: '_msnlq-rm-cm-gl-me-img' },
                ]);
                imageWrapper.innerHTML = "<img src='".concat(img.url, "' alt='").concat(img.file_name, "' />");
                imageWrapper.addEventListener('click', function () {
                    openOverlay_1(index);
                });
                mediacontainer_1 === null || mediacontainer_1 === void 0 ? void 0 : mediacontainer_1.appendChild(imageWrapper);
            });
            (_c = card.querySelector('._msnlq-glr-close')) === null || _c === void 0 ? void 0 : _c.addEventListener('click', function () {
                closeOverlay_1();
            });
            (_d = card.querySelector('._msnlq-glr-leftarrow')) === null || _d === void 0 ? void 0 : _d.addEventListener('click', function () {
                prevImage_1();
            });
            (_e = card.querySelector('._msnlq-glr-rightarrow')) === null || _e === void 0 ? void 0 : _e.addEventListener('click', function () {
                nextImage_1();
            });
        }
        //
        // Handle replies in the responses
        if (arg.interactions && arg.interactions.length > 0) {
            var container_1 = card.querySelector('._msnlq-int-replies');
            arg.interactions.forEach(function (interaction) {
                var cardElem = createElement('div');
                cardElem.innerHTML = replyCard(interaction);
                handleHeart(config, cardElem, interaction, personId);
                container_1 === null || container_1 === void 0 ? void 0 : container_1.appendChild(cardElem);
            });
        }
        // Handle the reply
        var replyWrapper = card.querySelector('._msnlq-int-makereply');
        replyWrapper === null || replyWrapper === void 0 ? void 0 : replyWrapper.appendChild(submitReplyCard(config, section, arg, personId));
    }
    if (type === 'flower') {
        if ((_f = section === null || section === void 0 ? void 0 : section.views) === null || _f === void 0 ? void 0 : _f.flowerCard) {
            card.innerHTML = section.views.flowerCard(customPayload);
        }
        else {
            card.innerHTML = flowerTemplate(arg);
        }
    }
    if (type === 'candle') {
        if ((_g = section === null || section === void 0 ? void 0 : section.views) === null || _g === void 0 ? void 0 : _g.candleCard) {
            card.innerHTML = section.views.candleCard(customPayload);
        }
        else {
            card.innerHTML = candleTemplate(arg);
        }
    }
    // console.log(card)
    return card;
};
export default CondolenceCard;
